// extracted by mini-css-extract-plugin
export default {"noPadding":"HomePageIntro-module--noPadding--59922","getStartedSection":"HomePageIntro-module--getStartedSection--32271"};